<template>
  <div
    class="giveaway-pop-item"
    v-track="[
      {
        act: 'click',
        params: {
          cfrom: '160|002|01|077',
          event_id: '160|002|01|077',
          page_name: 1,
          sku_id: giftItem.skuId,
          gift_type: giftItem.giftFlag,
          gift_content: contentChange(giftItem),
          position: positionKey + 1,
          isno_choose: giftItem.optionalGiftId ? 1 : 0
        }
      },
      {
        act: 'show',
        params: {
          cfrom: '160|003|02|077',
          event_id: '160|003|02|077',
          page_name: 1,
          sku_id: giftItem.skuId,
          gift_type: giftItem.giftFlag,
          gift_content: contentChange(giftItem),
          position: positionKey + 1,
          isno_choose: isOptional ? 1 : 0
        }
      }
    ]"
  >
    <div class="image" @click="handleSelect(giftItem.url)" tabindex="0">
      <img v-lazy="giftItem.smallPic" alt="赠品图片" />
      <!-- 会员加赠 -->
      <template v-if="giftItem.giftType == 42">
        <div class="p-item p-vip-pt" v-if="giftItem.vipGiftLevel == 1" aria-label="会员专享">
          <p>会员专享</p>
        </div>
        <div class="p-item p-vip-by" v-if="giftItem.vipGiftLevel == 2" aria-label="白银专享">
          <p>白银专享</p>
        </div>
        <div class="p-item p-vip-hj" v-else-if="giftItem.vipGiftLevel == 3" aria-label="黄金专享">
          <p>黄金专享</p>
        </div>
        <div class="p-item p-vip-zs" v-else-if="giftItem.vipGiftLevel == 4" aria-label="钻石专享">
          <p>钻石专享</p>
        </div>
      </template>
      <!-- 权益赠品 -->
      <template v-if="giftItem.giftType == 45 && isOptional">
        <div class="p-item p-gift" aria-label="已购权益">
          <p>已购权益</p>
        </div>
      </template>
    </div>
    <div class="content" @click="handleSelect(giftItem.url)" tabindex="0">
      <div class="title" :aria-label="giftItem.name">{{ giftItem.name }}</div>
      <div class="sub-title" v-if="giftItem.giftType != 43" :aria-label="giftItem.shortDesc">{{ giftItem.shortDesc }}</div>
      <div class="price" v-if="giftItem.marketPrice">
        <span class="zero-price">￥0</span>
        <span class="m-price" :aria-label="`原价￥${giftItem.marketPrice}`">￥{{ giftItem.marketPrice }}</span>
      </div>
    </div>
    <div
      class="right-side"
      @click="goLink(giftItem.url)"
      v-if="giftItem.url && !(env.isPadVivoApp && giftItem.giftFlag == 3)"
      tabindex="0"
      aria-label="查看详情"
    >
      <img class="icon-right" src="~assets/img/common/icon-right.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { giftContentChange } from '@/components/gift-popup/trackData'
import env from 'utils/clientEnv'
import app from 'utils/app'
export default {
  name: 'GiveawayPopItem',
  props: {
    giftItem: Object,
    positionKey: Number,
    isOptional: Boolean
  },
  computed: {
    ...mapGetters('detailv3', ['skuId'])
  },
  data() {
    return {
      contentChange: giftContentChange,
      env
    }
  },
  methods: {
    handleSelect(url) {
      if (this.isOptional) {
        this.$emit('select')
      } else {
        this.goLink(url)
      }
    },
    goLink(link) {
      if (link) {
        app.openNewWebview({
          url: link
        })
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
